import React, { useState } from 'react'
import styled from 'styled-components'
import { Tabs } from 'antd'
import { connect } from 'react-redux'
import { RootState } from 'Store'
import { selectCurrentUser } from 'Store/user/selector'
import HomePageLayout from 'Pages/Layout/PageLayout'
import Contents from './components/Contents'
import { selectContentList, selectContentListEvent } from 'Store/manage-content/selector'
const { TabPane } = Tabs

type Props = {} & ReduxProps

const ManageContents: React.FunctionComponent<Props> = props => {
  const [activeTab, setActiveTab] = useState('Roles' as string)

  const onChangeTab = (key: string) => {
    setActiveTab(key)
  }

  const getTab = () => {
    return (
      <StickyHeader>
        <Tabs onChange={onChangeTab} activeKey={activeTab}>
          {['Roles', 'Permissions'].map((item: string) => {
            return <TabPane tab={item} key={item}></TabPane>
          })}
        </Tabs>
      </StickyHeader>
    )
  }

  return (
    <>
      <HomePageLayout selected="contents" title="รายการคอนเทนต์" label="">
        <Contents />
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    dataList: selectContentList(state),
    listEvent: selectContentListEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const StickyHeader = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: -25px;
  background-color: #f8fafb;
  z-index: 1;
`

export default connect(mapStateToProps)(ManageContents)
